import { render } from "./headPortrait.vue?vue&type=template&id=21610488&scoped=true"
import script from "./headPortrait.vue?vue&type=script&lang=js"
export * from "./headPortrait.vue?vue&type=script&lang=js"

import "./headPortrait.vue?vue&type=style&index=0&id=21610488&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21610488"]])

export default __exports__